import React, {useState} from 'react'
import axios from 'axios';

import Trade from "./Trade"

import  useTradeStore  from '../../../stores/TradesStore'
import  useUserStore  from '../../../stores/UserStore'

function TradeStates() {
  const trades = useTradeStore((state) => state.trades)
  const userID = useUserStore((state) => state.userID)
  const [selectedList, setSelected] = useState([])




  const kill = async () => {
    for (const trade of selectedList) {
      const url = `/api/cancel/kill_trade/${trade}/blub/blub`;
      try {
        await axios.get(url, { timeout: 2000 });
      } catch (err) {
        console.log(err);
      }
    }
    setSelected([]);
  };

  const abort = async () => {
    for (const trade of selectedList) {
      const url = `/api/cancel/close_trade/${trade}/blub/blub`;
      try {
        await axios.get(url, { timeout: 2000 });
      } catch (err) {
        console.log(err);
      }
    }
    setSelected([]);
  };
  
  
  
  return (
    <div className="mobile_state_container">
      {/* <div className="cancel_kill_btn_container">
        <button className="btn cancel_button" onClick={() => abort()}>Cancel</button>
        <button className="btn kill_button" onClick={() => kill()}>Kill</button>
      </div> */}
      <div className="state_exchanges_container">
        {Object.keys(trades).map(function(exchange) {
          return (
              <div key={exchange} className="mobile_state_exchange_container">
                  <h3 className="states_exchange_title">{exchange.replaceAll(userID+'@', '').replaceAll('_', ' ')}</h3>
                  <ul className="states_ul" key={exchange}>  
                    
                    
                      {Object.keys(trades[exchange]).map(function(instrument) {
                          return Object.keys(trades[exchange][instrument]).map(function(side) {
                              return  Object.keys(trades[exchange][instrument][side]).map(function(trade_id) {
                                  const trade_unit = trades[exchange][instrument][side][trade_id]
                                  const stop_price = trade_unit.stop_price
                                  const exit_price = trade_unit.exit_price
                                  const targets = trade_unit.targets
                                  const positions = trade_unit.positions
                                  return <Trade key={trade_id} infos={trade_unit} selectedList={selectedList} setSelected={setSelected} />
                                  // return <li key={trade_id}>{targets.BTCUSDT}</li>
                              })
                          })
                      })}
                  </ul>
              </div>
          )
        })
        }
      </div>
  </div>
  )
}

export default TradeStates